var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.configObj
    ? _c("div", { staticClass: "page-container" }, [
        _c("div", { staticClass: "bg-img" }, [
          _c("img", {
            attrs: {
              src: _vm.imgSrcList.length && _vm.imgSrcList[0].img,
              alt: "",
            },
          }),
          _c("div", { staticClass: "mask", style: _vm.maskStyle }),
        ]),
        _c("div", { staticClass: "search-box" }, [
          _c("img", {
            attrs: {
              src: require("../../images/leftMenu.png"),
              alt: "",
              mode: "widthFix",
            },
          }),
          _c("div", { staticClass: "box line1", style: _vm.contentStyle }, [
            _c("i", { staticClass: "el-icon-search" }),
            _vm._v(_vm._s(_vm.hotWord)),
          ]),
        ]),
        _c("div", { staticClass: "diyStore", attrs: { id: "store" } }, [
          _c(
            "div",
            { staticClass: "pictrue overflow", style: _vm.logoStyleRadius },
            [_c("img", { attrs: { src: _vm.JavaMerchantConfigInfo.avatar } })]
          ),
          _c("div", { staticClass: "text" }, [
            _c("div", { staticClass: "acea-row row-middle" }, [
              _c("div", { staticClass: "name" }, [
                _vm._v(_vm._s(_vm.JavaMerchantBaseInfo.name)),
              ]),
              _c("div", { staticClass: "iconfont icon-xuanze" }),
            ]),
            _c("div", { staticClass: "merchantInfo flex mt5" }, [
              _c(
                "div",
                {
                  staticClass: "mr6 self_min merType",
                  style: { backgroundColor: _vm.themeColor },
                },
                [_vm._v("自营")]
              ),
              _c("div", { staticClass: "mr10 merType color-FAAD14" }, [
                _vm._v(_vm._s(_vm.JavaMerchantBaseInfo.merType)),
              ]),
              _c("div", { staticClass: "score" }, [
                _c(
                  "div",
                  { staticClass: "starsList flex" },
                  [
                    _vm._l(
                      _vm.JavaMerchantBaseInfo.starLevel,
                      function (itemn, indexn) {
                        return _c("div", { key: indexn }, [
                          _c("span", {
                            staticClass: "iconfont icon-pingfen",
                            style: { color: _vm.themeColor },
                          }),
                        ])
                      }
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              Number(_vm.JavaMerchantBaseInfo.starLevel) < 5,
                            expression:
                              "Number(JavaMerchantBaseInfo.starLevel) < 5",
                          },
                        ],
                        staticClass: "flex",
                      },
                      _vm._l(_vm.noStarLevel, function (itemn, indexn) {
                        return _c("span", {
                          key: indexn,
                          staticClass: "iconfont icon-pingfen noCheck",
                        })
                      }),
                      0
                    ),
                  ],
                  2
                ),
              ]),
            ]),
          ]),
          _c(
            "button",
            {
              staticClass: "merCollect",
              style: _vm.followColor,
              attrs: { "hover-class": "none" },
            },
            [
              _c("span", { staticClass: "iconfont icon-guanzhu" }),
              _vm._v(
                _vm._s(_vm.JavaMerchantBaseInfo.isCollect ? "已关注" : "关注") +
                  " "
              ),
            ]
          ),
        ]),
        _c("div", { staticClass: "banner-two" }, [
          _c("div", { staticClass: "img-box" }, [
            _vm.swiperType == 0
              ? _c("div", { staticClass: "img-item item-left" }, [
                  _vm.imgSrcList.length > 1 && _vm.imgSrcList[1].img
                    ? _c("img", {
                        staticClass: "img-left",
                        style: _vm.contentStyleBanner,
                        attrs: {
                          src:
                            _vm.imgSrcList.length > 1 && _vm.imgSrcList[1].img,
                          alt: "",
                        },
                      })
                    : _c(
                        "div",
                        {
                          staticClass: "empty-box empty-left",
                          style: _vm.contentStyleBanner,
                        },
                        [
                          _c("span", {
                            staticClass: "iconfont iconfont icontupian",
                          }),
                        ]
                      ),
                ])
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "img-item",
                class: _vm.swiperType == 0 ? "item-middle" : "item-middle-2",
              },
              [
                _vm.imgSrcList.length && _vm.imgSrcList[0].img
                  ? _c("img", {
                      staticClass: "img-middle",
                      style: _vm.contentStyleBanner,
                      attrs: {
                        src: _vm.imgSrcList.length && _vm.imgSrcList[0].img,
                        alt: "",
                      },
                    })
                  : _c(
                      "div",
                      {
                        staticClass: "empty-box empty-middle",
                        style: _vm.contentStyleBanner,
                      },
                      [
                        _c("span", {
                          staticClass: "iconfont iconfont icontupian",
                        }),
                      ]
                    ),
                _c("div", [
                  _vm.docType === 0
                    ? _c(
                        "div",
                        { staticClass: "dot more-dot", style: _vm.dotStyle },
                        [
                          _c("div", {
                            staticClass: "dot-item",
                            style: {
                              background: _vm.themeStyle
                                ? _vm.configObj.docColor.color[0].item
                                : _vm.themeColor,
                            },
                          }),
                          _c("div", { staticClass: "dot-item" }),
                          _c("div", { staticClass: "dot-item" }),
                        ]
                      )
                    : _vm._e(),
                  _vm.docType === 1
                    ? _c(
                        "div",
                        {
                          staticClass: "dot more-dot line-dot",
                          style: _vm.dotStyle,
                        },
                        [
                          _c("div", {
                            staticClass: "line_dot-item",
                            style: {
                              background: _vm.themeStyle
                                ? _vm.configObj.docColor.color[0].item
                                : _vm.themeColor,
                            },
                          }),
                          _c("div", { staticClass: "line_dot-item" }),
                          _c("div", { staticClass: "line_dot-item" }),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]
            ),
            _vm.swiperType == 0
              ? _c("div", { staticClass: "img-item item-right" }, [
                  _vm.imgSrcList.length > 2 && _vm.imgSrcList[2].img
                    ? _c("img", {
                        staticClass: "img-right",
                        style: _vm.contentStyleBanner,
                        attrs: {
                          src:
                            _vm.imgSrcList.length > 2 && _vm.imgSrcList[2].img,
                          alt: "",
                        },
                      })
                    : _c(
                        "div",
                        {
                          staticClass: "empty-box empty-right",
                          style: _vm.contentStyleBanner,
                        },
                        [
                          _c("span", {
                            staticClass: "iconfont iconfont icontupian",
                          }),
                        ]
                      ),
                ])
              : _vm._e(),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }